__turbopack_context__.v({
  "blocksBackgroundColor": "CleverSlider-module-scss-module__PQeFaG__blocksBackgroundColor",
  "blocksFontColor": "CleverSlider-module-scss-module__PQeFaG__blocksFontColor",
  "childSlideContainer": "CleverSlider-module-scss-module__PQeFaG__childSlideContainer",
  "container": "CleverSlider-module-scss-module__PQeFaG__container",
  "innerContainer": "CleverSlider-module-scss-module__PQeFaG__innerContainer",
  "innerContainerDisallowEvents": "CleverSlider-module-scss-module__PQeFaG__innerContainerDisallowEvents",
  "innerContainerHidden": "CleverSlider-module-scss-module__PQeFaG__innerContainerHidden",
  "scrollArrow": "CleverSlider-module-scss-module__PQeFaG__scrollArrow",
  "scrollArrowNext": "CleverSlider-module-scss-module__PQeFaG__scrollArrowNext",
  "scrollArrowPrev": "CleverSlider-module-scss-module__PQeFaG__scrollArrowPrev",
  "secondaryNavBackgroundColor": "CleverSlider-module-scss-module__PQeFaG__secondaryNavBackgroundColor",
  "slideContainer": "CleverSlider-module-scss-module__PQeFaG__slideContainer",
  "slideContainerContainer": "CleverSlider-module-scss-module__PQeFaG__slideContainerContainer",
  "sliderContainer": "CleverSlider-module-scss-module__PQeFaG__sliderContainer",
  "sliderContainerShowGradientBoth": "CleverSlider-module-scss-module__PQeFaG__sliderContainerShowGradientBoth",
  "sliderContainerShowGradientLeft": "CleverSlider-module-scss-module__PQeFaG__sliderContainerShowGradientLeft",
  "sliderContainerShowGradientRight": "CleverSlider-module-scss-module__PQeFaG__sliderContainerShowGradientRight",
  "themeBackgroundColor": "CleverSlider-module-scss-module__PQeFaG__themeBackgroundColor",
  "themeFontColor": "CleverSlider-module-scss-module__PQeFaG__themeFontColor",
  "track": "CleverSlider-module-scss-module__PQeFaG__track",
  "trackContainer": "CleverSlider-module-scss-module__PQeFaG__trackContainer",
});
